module.exports = __webpack_public_path__ + "media/images/solarium-625a4319f4549e0ebc9f1607f65d4bab.svg";